import { render } from "./company-settings.vue?vue&type=template&id=744e6f69&ts=true"
import script from "./company-settings.vue?vue&type=script&lang=ts"
export * from "./company-settings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__